var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.show,"variant":_vm.variant}},[_vm._v(_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }